import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=48366875&scoped=true&lang=pug&"
import script from "./navigation.vue?vue&type=script&lang=ts&"
export * from "./navigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48366875",
  null
  
)

export default component.exports